import { useState, forwardRef } from 'react';
import { observeClickOutside } from 'react-ref-observe';
import { Button, Dialog, Stack } from '@etg/wings';
import { Info } from '@phosphor-icons/react';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import SeatCharacteristicsToggleContent from './SeatCharacteristicsToggleContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  legendButton: css`
    cursor: pointer;
    height: 34px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: fit-content;
    z-index: 2;
  `,
  dialogContent: css`
    position: inherit;

    @media ${mediaQueries.medium.up} {
      position: sticky;
    }
  `
};
const SeatCharacteristicsToggleButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    seatCharacteristics
  } = _ref;
  const {
    t
  } = useTranslation();
  const seatingLegendButtonTitle = t('Product.SeatMap.Characteristics.Label');
  const [isOpen, setIsOpen] = useState(false);
  observeClickOutside([ref], () => {
    setIsOpen(false);
  });
  const closeDialog = () => setIsOpen(false);
  const openDialog = () => setIsOpen(true);
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsxs(Button, {
      className: styles.legendButton,
      "data-testid": "seatMap-expandLegendButton",
      id: "seatMap-expandLegendButton",
      onClick: openDialog,
      ref: ref,
      type: "button",
      children: [/*#__PURE__*/_jsx(Info, {
        size: 20
      }), seatingLegendButtonTitle]
    }), isOpen && /*#__PURE__*/_jsx(Dialog, {
      className: styles.dialogContent,
      closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
      isOpen: true,
      onDismiss: closeDialog,
      title: seatingLegendButtonTitle,
      children: /*#__PURE__*/_jsxs(Stack, {
        align: "start",
        spacing: 16,
        children: [seatCharacteristics === null || seatCharacteristics === void 0 ? void 0 : seatCharacteristics.map(item => /*#__PURE__*/_jsx(SeatCharacteristicsToggleContent, {
          characteristic: item.characteristic,
          priceFrom: item.price
        }, item.characteristic)), /*#__PURE__*/_jsx(SeatCharacteristicsToggleContent, {
          isUnavailable: true
        })]
      })
    })]
  });
});
export default SeatCharacteristicsToggleButton;
//# sourceMappingURL=SeatCharacteristicsToggleButton.js.map